import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Modal, Box, Typography, Button, Grid } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import CustomInput from "../ui/CustomInput";
import axios from "../../api/axiosClient";
import { useLoading } from "../LoadingContext";
import { handleError } from "../../services/serviceBase";
import { useNavigate } from "react-router-dom";

const ForceInTransitModal = (props) => {
  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "5px",
    width: 500,
  };

  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [pickupDate, setPickupDate] = useState(null);

  const handleClose = () => {
    props.handleCloseModal();
  };  

  const forceRAInTransit = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    if (pickupDate != null) {
      params.append("pickupDate", pickupDate);
    }
    let url = "returnFiles/" + props.idReturnFileHead + "/forceintransit";
    if (params.size > 0) {
      url += "?" + params.toString();
    }
    axios
      .post(url)
      .then(() => {
        setLoading(false);
        navigate("/RASearch");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid container>
          <Grid item lg={12} mb={1}>
            <PageHeader
              title={intl.formatMessage({ id: "RADetails.ForceInTransit" }) + ' [' + props.returnFileKey + ']' }
            />
          </Grid>
          <Grid item lg={12} mb={1}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.PickUpDate",
              })}
              type="date"
              valueRef={pickupDate}
              setValue={setPickupDate}
              textCol={3}
              inputCol={9}
            />
          </Grid>
          <Grid item lg={12}>
            <Button
              variant="outlined"
              style={{
                backgroundColor: "#85abd5",
                color: "white",
                borderColor: "#85abd5",
              }}
              sx={{ width: "100%" }}
              onClick={(e) => forceRAInTransit()}
            >
              {intl.formatMessage({ id: "General.Save" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ForceInTransitModal;
